/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/

import React, { useEffect, useState } from 'react';
import { TextInput } from '@carbon/react';
import { useTranslation } from 'react-i18next';

const TestToolMutualAuth = ({ mutualCreds, onChange }) => {
  const [mutualVersion, setMutualVersion] = useState('');
  const [mutualSid, setMutualSid] = useState('');
  const [mutualNonce, setMutualNonce] = useState('');
  const [mutualVkc, setMutualVkc] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    setMutualNonce(mutualCreds.mutualVersion ?? '');
    setMutualSid(mutualCreds.mutualSid ?? '');
    setMutualNonce(mutualCreds.mutualNonce ?? '');
    setMutualVkc(mutualCreds.mutualVkc ?? '');
  }, [mutualCreds.mutualNonce, mutualCreds.mutualSid, mutualCreds.mutualVersion, mutualCreds.mutualVkc]);

  const handleHttpMutualVersionChange = (event) => {
    const mutualVersion = event.target.value;
    setMutualVersion(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ mutualVersion, mutualSid, mutualNonce, mutualVkc });
    }
  };

  const handleHttpMutualSidChange = (event) => {
    const mutualSid = event.target.value;
    setMutualSid(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ mutualVersion, mutualSid, mutualNonce, mutualVkc });
    }
  };

  const handleHttpMutualNonceChange = (event) => {
    const mutualNonce = event.target.value;
    setMutualNonce(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ mutualVersion, mutualSid, mutualNonce, mutualVkc });
    }
  };

  const handleHttpMutualVkcChange = (event) => {
    const mutualVkc = event.target.value;
    setMutualVersion(event.target.value);
    if (onChange && typeof onChange === 'function') {
      onChange({ mutualVersion, mutualSid, mutualNonce, mutualVkc });
    }
  };

  return (
    <div className="testToolMutualAuth">
      <div className="mutualversion">
        <div className="labelText">{t('version')}</div>
        <TextInput id="mutualversion" hideLabel labelText={t('version')} value={mutualVersion} onChange={handleHttpMutualVersionChange} />
      </div>

      <div className="mutualsid">
        <div className="labelText">{t('session_identifier')}</div>
        <TextInput id="mutualsid" labelText={t('session_identifier')} hideLabel value={mutualSid} onChange={handleHttpMutualSidChange} />
      </div>

      <div className="mutualnonce">
        <div className="labelText">{t('nonce')}</div>
        <TextInput id="mutualnonce" labelText={t('nonce')} hideLabel value={mutualNonce} onChange={handleHttpMutualNonceChange} />
      </div>

      <div className="mutualvkc">
        <div className="labelText">{t('verification_value')}</div>
        <TextInput id="mutualvkc" labelText={t('verification_value')} hideLabel value={mutualVkc} onChange={handleHttpMutualVkcChange} />
      </div>
    </div>
  );
};

export default TestToolMutualAuth;
